import type { ProjectLite } from "@/entities/project";
import type { UseListOptions } from "@/hooks/queries";

import { useList } from "@/hooks/queries";

export const useGetProjects = (options?: UseListOptions<ProjectLite>) => {
  const { data, ...queryResult } = useList<ProjectLite>("projects", options);

  return {
    projects: data?.data ?? [],
    ...queryResult,
  };
};
